export default __webpack_public_path__ + "static/media/blue-wave.cf7d3651.jpg";